export const VIN_CHECK = {
    FAIL: 'Fail',
    PASS: 'Pass',
    NO_RESULT: 'No Result',
};



// WEBPACK FOOTER //
// ./src/modules/Leads/constants/vinCheck.js